import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";
export const getProjectsList = (id, query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/projects/user/${id}${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getReginationCheckList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/employee/resignation/checklist${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const uploadFnfLetters = (id, data, token) =>
  axios.post(
    `${baseUrl}/employee/resignation/ExitChecklistUpdate/${id}`,
    data,
    {
      headers: {
        authorization: token,
      },
    }
  );
